import { TableSortLabel } from '@mui/material';

import { Survey_Location_Statistics_Sort_By } from '@occc/graphql';

import { TableCell, TableHead, TableRow } from '@occc/ui-design-system';
import { SortingProps } from '../../../hooks/useSortingParams';

export type SurveyDetailsTableHeader = {
  label: string;
  sortingField?: string;
};

export const headers: SurveyDetailsTableHeader[] = [
  { label: '', sortingField: '' },
  { label: 'Site ID', sortingField: '' },
  { label: 'Site Name', sortingField: '' },
  { label: 'Responses', sortingField: Survey_Location_Statistics_Sort_By.TotalResponses },
  { label: 'Top Response', sortingField: Survey_Location_Statistics_Sort_By.TopResponse },
  { label: 'Bottom Response', sortingField: Survey_Location_Statistics_Sort_By.BottomResponse },
];

type SurveyLocationsTableHeadProps = {
  sortingProps?: SortingProps;
};

export const SurveyLocationsTableHead = ({ sortingProps }: SurveyLocationsTableHeadProps) => (
  <TableHead>
    <TableRow>
      {headers.map(({ label, sortingField }) => {
        if (!sortingField) {
          return <TableCell key={label}>{label}</TableCell>;
        }

        return (
          <TableCell key={label}>
            <TableSortLabel
              active={sortingField === sortingProps?.field}
              direction={sortingProps?.direction}
              onClick={
                sortingProps?.onClick ? () => sortingProps.onClick?.(sortingField) : undefined
              }
            >
              {label}
            </TableSortLabel>
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);
